package com.iregained.site.components.sections.contact.styles

import com.iregained.site.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.selectors.focus
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

val ContactB2bContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().custom.lightGray) // Contrasts with Phase 1
}

val ContactB2bGridStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(1200.px).gap(60.px)
}

// --- LEFT COLUMN: LOGISTICS TIMELINE ---
val LogisticsColumnStyle = CssStyle.base {
    Modifier.fillMaxWidth()
}

val LogisticsTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(2.cssRem).fontWeight(FontWeight.Bold)
        .margin(bottom = 16.px)
}

val LogisticsDescStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f)).fontSize(1.125.cssRem)
        .lineHeight(1.6).margin(bottom = 40.px)
}

val TimelineStepRowStyle = CssStyle.base {
    Modifier.fillMaxWidth().gap(20.px).margin(bottom = 32.px)
}

val TimelineNumberCircleStyle = CssStyle.base {
    Modifier.size(48.px).minWidth(48.px).borderRadius(50.percent)
        .backgroundColor(colorMode.toSitePalette().brand.primary).color(Colors.White).fontSize(1.25.cssRem)
        .fontWeight(FontWeight.Bold).display(DisplayStyle.Flex).justifyContent(JustifyContent.Center)
        .alignItems(AlignItems.Center)
}

val TimelineStepTitleStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(1.25.cssRem).fontWeight(FontWeight.Bold)
        .margin(bottom = 8.px)
}

val TimelineStepDescStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText.toRgb().copyf(alpha = 0.8f)).fontSize(1.cssRem)
        .lineHeight(1.5)
}

// --- RIGHT COLUMN: THE FORM ---
val FormCardStyle = CssStyle.base {
    Modifier.fillMaxWidth().backgroundColor(Colors.White).borderRadius(16.px).padding(40.px)
        .boxShadow(0.px, 12.px, 40.px, color = Colors.Black.copy(alpha = 8))
}

val FormLabelStyle = CssStyle.base {
    Modifier.color(colorMode.toSitePalette().custom.darkText).fontSize(0.9.cssRem).fontWeight(FontWeight.SemiBold)
        .margin(bottom = 8.px).display(DisplayStyle.Block)
}

// Shared styling for Inputs and Select Dropdowns
val FormInputStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().padding(leftRight = 16.px, topBottom = 12.px).margin(bottom = 24.px).borderRadius(8.px)
            .border(1.px, LineStyle.Solid, Colors.DarkGray).backgroundColor(Colors.White).fontSize(1.cssRem)
            .color(colorMode.toSitePalette().custom.darkText).transition(Transition.of("border-color", 200.ms))
    }
    focus {
        Modifier.border(1.px, LineStyle.Solid, colorMode.toSitePalette().brand.primary)
            .outline(0.px) // Removes default browser focus ring
    }
}

val FormSubmitButtonStyle = CssStyle {
    base {
        Modifier.fillMaxWidth().backgroundColor(colorMode.toSitePalette().brand.primary).color(Colors.White)
            .fontSize(1.1.cssRem).fontWeight(FontWeight.SemiBold).padding(topBottom = 16.px).borderRadius(8.px)
            .border(0.px).cursor(Cursor.Pointer).transition(Transition.of("background-color", 200.ms))
    }
    hover {
        Modifier.backgroundColor(colorMode.toSitePalette().brand.primaryHover)
    }
}